// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsblxxhzcx-index-main_right_content-1lTMd","table":"components-tjcx-xsblxxhzcx-index-table-1KljU"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsblxxhzcx/index.css
// module id = 2320
// module chunks = 0